import React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import {StoreConfigLoyaltyApi} from "../../../services/Api/types";
import {ReactComponent as CashbackOutlineIco} from "../../../../images/icons/cashback-outline.svg";
import PopupModal from "../../Modal/PopupModal";

interface OwnProps {
    config_loyalty: StoreConfigLoyaltyApi,
    onHide: () => void,
    onShow?: () => void,
    onClick: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function LoyaltyCashbackInfoModalComponent(props: Props) {
    const {t} = useTranslation();

    return <PopupModal bodyContent={
        <>
            {props.config_loyalty.cashback?.info && (
                <p className="text-center">
                    {props.config_loyalty.cashback?.info}
                </p>
            )}
        </>
        }
        title={t("modules.user.field.cashback_program.title")}
        description={t("modules.user.field.cashback_program.description")}
        show
        onHide={props.onHide}
        onShow={props.onShow}
        headerIcon={<CashbackOutlineIco/>}
        headerIconClassName="text-success"
        primaryButton={
            <button className={"btn btn-default w-100"} onClick={props.onHide}>
                {t("modules.user.action.ok.title")}
            </button>
        }
    />
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(LoyaltyCashbackInfoModalComponent));
